import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AdminActionCreators from "../../actions/admin.actions";
import * as DTOS from "../../FeralScan.dtos";
import { LocalForm, Control } from 'react-redux-form';
import ModalMessage from '../Common/Modal';
import { IAppState } from '../../app';
import PaginatedTable from '../Data/PaginatedTable/PaginatedTable';
import { Link } from 'react-router-dom';
import { number } from 'prop-types';

type UserAdminEditProps = {
    user: DTOS.User;
}

type UserAdminEditActions = {
}

type UserAdminEditPropsMapped = {
    loading: boolean;
    saving: boolean;
    userRoles: DTOS.UserRole[];
    userRolesLoading: boolean;
}

type UserAdminEditActionsMapped = {
    updateUser: typeof AdminActionCreators.editUser;
}

type UserAdminEditAllPropsInherited = UserAdminEditProps & UserAdminEditActions;
type UserAdminEditAllPropsMapped = UserAdminEditPropsMapped & UserAdminEditActionsMapped;

type UserAdminEditAllProps = Partial<UserAdminEditAllPropsMapped> & UserAdminEditAllPropsInherited;

interface IUserAdminEditState {
    showDeleteModal: boolean;
    userReadyToSave: any;
}

class UserAdminEdit extends React.Component<UserAdminEditAllProps, IUserAdminEditState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showDeleteModal: false,
            userReadyToSave: undefined
        }

        this.onDeleteHideModel = this.onDeleteHideModel.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
    }


    onDeleteHideModel() {
        this.setState({
            showDeleteModal: false,
            userReadyToSave: undefined
        });
    }

    onDeleteItem() {
        this.saveUser(this.state.userReadyToSave);

        this.setState({
            showDeleteModal: false,
            userReadyToSave: undefined
        });
    }

    onSubmit(user) {
        if (!this.props.user.obsolete && user.obsolete) {
            this.setState({
                showDeleteModal: true,
                userReadyToSave: user
            });
        } else {
            this.saveUser(user);
        }
    }

    saveUser(user: DTOS.User) {
        if (this.props.user && user) {
            // copy from props to make sure we have the correct user ID
            var submitUser = { ...this.props.user }

            submitUser.fullName = user.fullName;
            submitUser.email = user.email;
            submitUser.obsolete = user.obsolete;
            submitUser.emailVerified = user.emailVerified;
            submitUser.postcode = user.postcode;
            submitUser.mobileNumber = user.mobileNumber;
            submitUser.apcCode = user.apcCode;
            submitUser.probationary = user.probationary;
            //submitUser.includeReportingData = user.includeReportingData;

            this.props.updateUser(submitUser);
        }
    }

    renderFormRow(label: string, formComponent: any) {
        return <div className="form-group row py-2 border-bottom">
            <label className="col-md-3">{label}</label>
            <div className="col-md-9">
                {formComponent}
            </div>
        </div>
    }

    render() {

        const { user, loading, saving } = this.props;

        const userEditForm = user ? <LocalForm
            model="user"
            onSubmit={user =>
                this.onSubmit(user)
            }
            validateOn="submit"
            className="form col-12"
        >
            {
                this.renderFormRow('APC Code', <Control.text
                    model=".apcCode"
                    id="apcCode"
                    className={"form-control"}
                    maxLength={100}
                    required={false}
                    defaultValue={user.apcCode}
                />)
            }

            {
                this.renderFormRow('First Name', <Control.text
                    model=".fullName"
                    id="fullName"
                    className={"form-control"}
                    maxLength={100}
                    required={true}
                    defaultValue={user.fullName}
                />)
            }

            {
                this.renderFormRow('Surname', <Control.text
                    model=".surname"
                    id="surname"
                    className={"form-control"}
                    maxLength={100}
                    required={true}
                    defaultValue={user.surname}
                />)
            }

            {
                this.renderFormRow('Email', <Control.text
                    model=".email"
                    id="email"
                    className={"form-control"}
                    maxLength={100}
                    required={true}
                    defaultValue={user.email}
                />)
            }

            {
                this.renderFormRow('Post Code', <Control.text
                    model=".postcode"
                    id="postcode"
                    className={"form-control"}
                    maxLength={100}
                    required={false}
                    defaultValue={user.postcode}
                />)
            }

            {
                this.renderFormRow('Mobile Number', <Control.text
                    model=".mobileNumber"
                    id="mobileNumber"
                    className={"form-control"}
                    maxLength={100}
                    required={false}
                    defaultValue={user.mobileNumber}
                />)
            }

            {
                this.renderFormRow('Platypus Seen', <Control.text
                    model=".platypusSeen"
                    id="platypusSeen"
                    className={"form-control"}
                    disabled={true}
                    required={false}
                    defaultValue={user.platypusSeen}
                />)
            }

            {
                this.renderFormRow('Account Activated (email verified)', <Control.checkbox
                    model=".emailVerified"
                    id="emailVerified"
                    className="form-control form-check"
                    defaultChecked={user.emailVerified}
                />)
            }

            {
                this.renderFormRow('Deleted (disabled/obsolete)', <Control.checkbox
                    model=".obsolete"
                    id="obsolete"
                    className="form-control form-check"
                    defaultChecked={user.obsolete}
                />)
            }

            {
                this.renderFormRow('Probationary', <Control.checkbox
                    model=".probationary"
                    id="probationary"
                    className="form-control form-check"
                    defaultChecked={user.probationary}
                />)
            }

            {
                this.renderFormRow('Email Opt Out (left program)', <Control.checkbox
                    model=".emailOptOut"
                    id="emailOptOut"
                    className="form-control form-check"
                    defaultChecked={user.emailOptOut}
                    disabled={true}
                />)
            }
            <button className="btn btn-lg btn-primary my-3" disabled={saving}>Save Changes</button>
        </LocalForm> : undefined;

        return (
            <>
                {userEditForm}
                <div className="col-12">
                    <h3>Sites</h3>
                    <PaginatedTable
                        countPerPage={Number.MAX_SAFE_INTEGER}
                        data={this.props.userRoles}
                        dataColumns={[
                            {
                                label: "Site",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => ur.plot ? <Link to={`/admin/site/${ur.plot.id}`}>{ur.plot.name}</Link> : <span>N/A</span>
                            },
                            {
                                label: "Role",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => <span>{ur.role.name}</span>
                            }
                        ]}
                        dataLoading={this.props.userRolesLoading}
                        dataSortOptions={undefined}
                        hidePaginationControls={true}
                        sort={undefined}
                        tableClassName={"table-sm table-bordered table-hover"}
                    />
                </div>
                <ModalMessage
                    onRequestClose={this.onDeleteHideModel}
                    onNegativeResponse={this.onDeleteHideModel}
                    onPositiveResponse={this.onDeleteItem}
                    isOpen={this.state.showDeleteModal}
                    label="Delete User"
                    message="Are you sure you want to delete this user?"

                    positiveResponseLabel="Delete"
                    positiveResponseClass="btn-danger"
                    negativeResponseLabel="Cancel"
                    negativeResponseClass="btn-secondary"
                />
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: UserAdminEditAllProps): UserAdminEditPropsMapped => {

    return {
        loading: state.admin.usersLoading,
        saving: state.admin.userSaving,
        userRoles: state.admin.userRoles,
        userRolesLoading: state.admin.userRolesLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<UserAdminEditActionsMapped>({
        updateUser: AdminActionCreators.editUser,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdminEdit);